<template>
  <div>
    <Lottie
      class="lottie-wrapper"
      ref="lottie"
      :animation-data="lottieFile"
      :auto-play="true"
      :loop="true"
      width="45px"
      height="45px"
    />
  </div>
</template>

<script>
import Lottie from './Lottie.vue'
import lottieFile from '../lotties/liveSearchLoading.json'

export default {
  name: 'SearchLoadingLottie',
  components: {
    Lottie
  },
  data () {
    return {
      lottieFile
    }
  }
}
</script>
